module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'synbrr60',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
